import {ReportType} from '../../constants'
import {AccessRights} from 'constants'
import {Feature} from '../../../features/constants'

export const isReportAvailable = (type, userRights, features) => {
    const billingRights = userRights[AccessRights.GENERATE_MONEY_REPORTS]
    const overtimeAndLeaveTimeRights = userRights[AccessRights.MANAGE_PTO_AND_SICK] || userRights[AccessRights.MANAGE_USERS]
                                       || userRights[AccessRights.SUBMIT_OTHER_USER_TIME_TRACK] || userRights[AccessRights.SUBMIT_TIME_TRACK]
    const managerOrTTUserRights = userRights[AccessRights.MANAGE_USERS] || userRights[AccessRights.EDIT_HIERARCHY] || userRights[AccessRights.GENERATE_MONEY_REPORTS]
                                  || userRights[AccessRights.SUBMIT_OTHER_USER_TIME_TRACK] || userRights[AccessRights.SUBMIT_TIME_TRACK]

    switch (type) {
        case ReportType.STAFF_PERFORMANCE:
            return !!managerOrTTUserRights
        case ReportType.TIME_TRACK_IN_DETAIL:
            return !!managerOrTTUserRights && !!features[Feature.TTC]
        case ReportType.ESTIMATED_VS_ACTUAL:
            return !!managerOrTTUserRights && !!features[Feature.EST]
        case ReportType.OVERTIME:
            return !!overtimeAndLeaveTimeRights
        case ReportType.LEAVE_TIME:
            return !!overtimeAndLeaveTimeRights && !!features[Feature.LVT] && !!features[Feature.CLT]
        case ReportType.BILLING_SUMMARY:
            return !!billingRights && !!features[Feature.BTY]
        case ReportType.INVOICING:
            return !!billingRights && !!features[Feature.BRA]
        case ReportType.COST_OF_WORK:
            return !!billingRights && !!features[Feature.URA]
        case ReportType.PROFIT_LOSS:
            return !!billingRights && !!features[Feature.URA] && !!features[Feature.BRA]
    }
}


// WEBPACK FOOTER //
// ./web/js/reports/dashboard/createReportPopup/utils.js